import moment from 'moment'
function formatDateDDMMYYYY(date) {
  if (!date || !date.length) return ''
  return moment(new Date(date)).format('DD/MM/YYYY')
}
function sortISOStrings(inputArray = []) {
  if (typeof inputArray === 'string') return [inputArray]
  const momentObjects = inputArray.map(isoString => moment(isoString))
  momentObjects.sort((a, b) => a - b)
  const sortedISOStrings = momentObjects.map(momentObj => momentObj.toISOString())
  return sortedISOStrings
}
export {
  formatDateDDMMYYYY,
  sortISOStrings
}
